<div [ngClass]="{'container-01': cueElement.level === 0}">
  <figure class="image-outer">
    <picture class="lazyload-picture " [ngClass]="{'is-ready': cueElement.isLoaded, 'ratio-16-9': cueElement.aspectRadio === 'ratio-16-9', 'ratio-1-1': cueElement.aspectRadio === 'ratio-1-1'}">
      <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" class="lazyload-img" [alt]="cueElement.alt_text" (sdxInView)="inView = $event" [sdxLazyload]="cueElement.imageSources" [lazyloadIf]="inView" (lazyloaded)="cueElement.isLoaded = true;" />
    </picture>
  </figure>
</div>
